import request from "./http";
import qs from 'qs'

// 	 * 查询所有站点信息
export function findSubstation() {
    return request({
        url: "http://192.168.124.166:8080/cim/findSubstation",
        method: "get",
      
    });
}

// 	 * 根据文件路径查询所有svg进行解析出所有间隔并根据站点下的间隔进行对比
export function saveContrastCim(params) {
    return request({
        url: "http://192.168.124.166:8080/svg/contrastCim",
        method: "post",
        headers:{
            'Content-Type': 'multipart/form-data',
            'Accept':'*/*'
          },
        data:params
      
    });
}


// 	 * 将xml文件中的站点和间隔分别保存在库里
export function saveImportCim(params) {
    return request({
        url: "http://192.168.124.166:8080/cim/importCim",
        method: "post",
        headers:{
            'Content-Type': 'multipart/form-data',
            'Accept':'*/*'
          },
        data:params
      
    });
}

// 	 * 将xml文件中的站点和间隔分别保存在库里
export function cimDelete() {
    return request({
        url: "http://192.168.124.166:8080/cim/delete",
        method: "DELETE",
    });
}

// 	 * 设备定义-----查询所有设备树结构
export function getDeviceTree() {
    return request({
        url: "http://192.168.124.166:8080/device/getDeviceTree",
        method: "get",
    });
}

// 	 * 设备定义-----新增设备名称
export function createEntityType(params) {
    return request({
        url: "http://192.168.124.166:8080/device/createEntityType",
        method: "post",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'*/*'
          },
        params
    });
}

// 	 * 设备定义-----修改设备名称
export function updateEntityType(params) {
    return request({
        url: "http://192.168.124.166:8080/device/updateEntityType",
        method: "put",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}
// 	 * 设备定义-----删除设备名称
export function deleteEntityType(params) {
    return request({
        url: "http://192.168.124.166:8080/device/deleteEntityType",
        method: "DELETE",
        params
    });
}
// 	 * 设备定义-----根据设备Id查询设备属性
export function getAllByEntityTypeCode(params) {
    return request({
        url: "http://192.168.124.166:8080/device/getAllByEntityTypeCode",
        method: "get",
        params
    });
}
// 	 * 设备定义-----新增设备属性
export function insertMisTypeProperty(params) {
    return request({
        url: "http://192.168.124.166:8080/device/insertMisTypeProperty",
        method: "post",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'*/*'
          },
        params
    });
}
// 	 * 设备定义-----修改设备属性
export function updateMisTypeProperty(params) {
    return request({
        url: "http://192.168.124.166:8080/device/updateMisTypeProperty",
        method: "put",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'*/*'
          },
        params
    });
}

// 	 * 设备定义-----删除设备属性
export function deleteMisTypeProperty(params) {
    return request({
        url: "http://192.168.124.166:8080/device/deleteMisTypeProperty",
        method: "DELETE",
        params
    });
}


// 	 * 设备定义-----属性对比
export function propertyContrast(params) {
    return request({
        url: "http://192.168.124.166:8080/device/property/contrast",
        method: "post",
        headers:{
            'Content-Type': 'multipart/form-data',
            'Accept':'*/*'
          },
        data:params
    });
}


// 	 * 设备定义-----属性对比
export function propertyEqualt(params) {
    return request({
        url: "http://192.168.124.166:8080/device/property/equal",
        method: "post",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'*/*'
          },
        params
    });
}




